import { useMemo } from 'react';
import { buildMotorDrawerMetricCollapsibleGroups } from '../../../../utils/electronicsDashboardUtils';
import { MetricCollapsibleDrawerSection, type MotorDrawerSectionProps } from '../DrawerDraggableLayout';

const MotorMetricsDrawerSection = ({ motorPorts, projectCode }: MotorDrawerSectionProps) => {
  const metricGroups = useMemo(() => buildMotorDrawerMetricCollapsibleGroups(motorPorts, projectCode), [motorPorts, projectCode]);

  return <MetricCollapsibleDrawerSection groups={metricGroups} />;
};

export default MotorMetricsDrawerSection;
